import axios from 'axios'
import { API_BASE_URL, MOCK_AUTH } from '@/config'
import { auth } from '@/plugins/firebase'
import { mockToken } from '@/plugins/mockSession'

/**
 * Istanza HTTP unica dell'app. Ogni service importa questa, mai `axios` diretto.
 * NOTA: qui non si importa AuthService, altrimenti si crea un ciclo di import.
 */
const api = axios.create({
  baseURL: API_BASE_URL,
})

// Inietta un token fresco a ogni richiesta (Firebase li ruota ogni ora)
api.interceptors.request.use(async (config) => {
  if (MOCK_AUTH) {
    const token = mockToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  }

  const user = auth?.currentUser
  if (user) {
    config.headers.Authorization = `Bearer ${await user.getIdToken()}`
  }
  return config
})

// 401 => sessione scaduta o utente non autorizzato: torna al login.
// Usa `skipAuthRedirect: true` sulla singola richiesta per gestire il 401 a mano.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      window.location.href = '/auth/login'
    }
    return Promise.reject(error)
  }
)

/** Messaggio leggibile di un errore dell'API, da mostrare nei toast. */
export function apiErrorMessage(error, fallback) {
  const data = error?.response?.data
  if (data?.error === 'ValidationError') return 'Dati non validi: controlla i campi.'
  return API_MESSAGES[data?.message] || data?.message || fallback
}

// I messaggi di dominio dell'API sono in inglese: quelli che l'admin puo' incontrare, tradotti
const API_MESSAGES = {
  'Email already registered': "Esiste gia' un utente con questa email.",
  'A site with this URL already exists': "Esiste gia' un sito con questo indirizzo.",
  'The site has not been paired yet': 'Il sito non e’ ancora stato abbinato: non si puo’ attivare a mano.',
  'valid_until must be after valid_from': 'La fine del periodo deve venire dopo l’inizio.',
  'The plan is no longer offered': 'Il piano non e’ piu’ disponibile per nuovi abbonamenti.',
  'Unknown user': 'Utente inesistente.',
  'Unknown site': 'Sito inesistente.',
  'Unknown plan': 'Piano inesistente.',
  'The site is not paired yet': 'Il sito non è ancora abbinato.',
}

export default api
